<template>
  <div class="idcard-passport-info">

    <div :class="['info-box', type === 'passport' ? 'passport-info-height' : 'idcard-info-height']">
      <!-- 左边的图片 -->
      <div class="img-box">
        <div class="info-img"
          v-drag="{zoomIn: zoomIn, zoomOut: zoomOut}"
          :style="{ transform: 'scale(' + scale + ')', backgroundImage: 'url(' + info.url + ')' }">
        </div>
        <div class="scale-box">
          <img src="../../../../assets/imgs/upload/zoomin.png" class="icon-img" @click="zoomIn">
          <div class="middle-box"></div>
          <img src="../../../../assets/imgs/upload/zoomout.png" class="icon-img" @click="zoomOut">
        </div>
      </div>

      <!-- 右边的信息 -->
      <div class="right-box">

        <div :class="['info', type === 'passport' ? 'passport-info' : 'idcard-info']">

          <form-info
            :type="type"
            :formData="info"
            ref="formInfo"
            :applicantId="applicantId"
            :orderId="orderId"
            :currentMaterial="currentMaterial"
            :readOnly="readOnly"
            :cancelText="cancelText"
            :showCancel="showCancel"
            :showSave="showSave"
            @closeModal="closeModal"
            @updateOrder="updateOrder"
            @successTips="successTips">
          </form-info>

        </div>

      </div>

    </div>

  </div>
</template>

<script>

import FormInfo from './form-info';

export default {
  name: 'idcard-passport-info',
  components: {
    FormInfo,
  },
  props: {
    info: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
    orderId: {
      type: Number,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
    currentMaterial: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: '重新上传',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showSave: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scale: 1,
    };
  },
  methods: {
    // 放大
    zoomIn() {
      this.scale += 0.1;
    },
    // 缩小
    zoomOut() {
      if (this.scale > 1) {
        this.scale -= 0.1;
      }
    },
    saveOtherPlace() {
      this.$refs.formInfo.saveOtherPlace();
    },
    closeModal() {
      this.$emit('closeModal');
      this.resetScale();
    },
    updateOrder() {
      this.$emit('updateOrder');
    },
    successTips() {
      this.$emit('successTips');
    },
    checkValid() {
      this.$refs.formInfo.checkValid();
    },
    // 重置缩放比例
    resetScale() {
      this.scale = 1;
    },
  },
  directives: {
    drag: {
    // 指令的定义
      inserted(el, binding) {
        const imgDiv = el;
        imgDiv.onmousedown = function (e) {
          const disX = e.clientX - imgDiv.offsetLeft;
          const disY = e.clientY - imgDiv.offsetTop;
          document.onmousemove = function (e) {
            const left = e.clientX - disX;
            const top = e.clientY - disY;

            if (left > -450 && left < 450) { imgDiv.style.left = `${left}px`; }
            if (top > -300 && top < 550) { imgDiv.style.top = `${top}px`; }
          };
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
        imgDiv.onmousewheel = function (e) {
          const { zoomIn, zoomOut } = binding.value;
          if (e.deltaY < 0) {
            zoomIn();
          } else {
            zoomOut();
          }
        };
      },
    },
  },
};
</script>

<style lang="less" scoped>

div.idcard-passport-info {
  div.info-box{
    display: flex;
    justify-content: center;
    align-items: center;
    div.img-box{
      width: 490px;
      height: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;
      user-select: none;
      div.scale-box{
        position: absolute;
        bottom: 10px;
        left: 400px;
        width: 80px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #000000;
        border-radius: 16px;
        opacity: 0.5;
        div.middle-box{
          width: 1px;
          height: 32px;
          border: none;
          border-left: 1px solid #ffffff;
          opacity: .1;
          margin: 0 6px;
        }
        img.icon-img{
          cursor: pointer;
        }
      }
      div.info-img{
        width: 490px;
        position: absolute;
        height: 330px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }
    div.right-box{
      position: relative;
    }
    div.info{
      width: 370px;
      border-left: 1px solid #f0f0f0;
      padding: 20px 30px 64px;
    }
    div.passport-info{
      height: 600px;
      overflow-y: scroll;
    }
    div.idcard-info{
      height: 510px;
    }
  }
  div.passport-info-height{
    height: 600px;
  }
  div.idcard-info-height{
    height: 510px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/idcard-passport-info-modal/idcard-passport-info.vue